import { type ForwardedRef, type MutableRefObject, useImperativeHandle, useRef } from 'react';

export const useRefAndForward = <Value>(
  initialValue: Value,
  forwardedRef: ForwardedRef<NonNullable<Value>>,
): MutableRefObject<Value> => {
  const ref = useRef<Value>(initialValue);
  useImperativeHandle(forwardedRef, () => ref.current as NonNullable<Value>);
  return ref;
};
